import type { GanttDependencyDto } from '../types';

const DELAY_MS = 300;

function delay(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

/**
 * Finish-to-start dependency edges between the top-level mock tasks defined in
 * `tasks.mock.ts`. Predecessor/successor ids must match real mock task ids so
 * the chart renders connector arrows end-to-end in mock mode.
 */
const MOCK_DEPENDENCIES: GanttDependencyDto[] = [
  { id: 'dep-1', predecessorTaskId: 'task-1', successorTaskId: 'task-2', type: 'FS', lagDays: 0 },
  { id: 'dep-2', predecessorTaskId: 'task-2', successorTaskId: 'task-3', type: 'FS', lagDays: 1 },
  { id: 'dep-3', predecessorTaskId: 'task-3', successorTaskId: 'task-5', type: 'FS', lagDays: 0 },
  { id: 'dep-4', predecessorTaskId: 'task-4', successorTaskId: 'task-6', type: 'FS', lagDays: 2 },
  { id: 'dep-5', predecessorTaskId: 'task-6', successorTaskId: 'task-7', type: 'FS', lagDays: 0 },
];

export async function getMockGanttDependencies(_projectId: string): Promise<GanttDependencyDto[]> {
  await delay(DELAY_MS);
  return MOCK_DEPENDENCIES.map((d) => ({ ...d }));
}
